<template>
  <div
    @click="goDetail(courseInfo.id)"
    :class="{
      'h5-course-card': isH5,
      'course-card': !isH5,
      'small-card': type === 'small',
      'big-card': type === 'big',
      'hidden-ios': iosInReview && courseInfo.goods.price > 0,
    }"
  >
    <div class="cover-wrap">
      <img
        class="cover"
        :src="courseInfo.cover_url + '?imageView2/0/w/480'"
        alt=""
      />
    </div>
    <!-- 课程信息 -->
    <div class="info-wrap">
      <p class="title">
        <span v-if="courseInfo.category_name" class="course-tag">
          {{ courseInfo.category_name }}</span
        >
        {{ courseInfo.course_name }}
      </p>
      <div class="course-info">
        <div class="price-activity-wrap">
          <!-- 价格 -->
          <p v-if="courseInfo.goods" class="price-wrap">
            <!-- 活动价 -->
            <span v-if="courseInfo.activetyPrice" class="activity-price"
              ><i>￥</i>{{ courseInfo.activetyPrice }}</span
            >
            <!-- 原价 -->
            <span v-if="courseInfo.goods.fee_type === 1" class="free-price"
              >免费</span
            >
            <span
              v-else
              class="price"
              :class="{ 'text-through': courseInfo.activetyPrice }"
            >
              <i>￥</i>{{ courseInfo.originPrice / 100 }}
            </span>
          </p>
          <!-- 营销标识 -->
          <span class="activity-mark" v-if="activityText">{{
            activityText
          }}</span>
        </div>
        <!-- 课时信息 -->
        <p class="data-STATS">
          <span class="lesson">{{ courseInfo.lesson_count }}课时</span>
          <span
            v-if="
              courseInfo.goods && courseInfo.goods.show_enrollment_count === 1
            "
            ><span class="separate"></span
            >{{ million(courseInfo.enrollment_count) }}人报名</span
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import courseCard from "@saas/components/src/mixins/courseCard";
import { isH5, isMobile } from "@saas/components/src";
import { million } from "@saas/components/src/utils/utils";
export default {
  mixins: [courseCard],
  props: {
    type: {
      type: String,
      default: "big",
    },
    courseInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    showOrgName: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      million,
      isH5: isH5(),
    };
  },
  methods: {
    goDetail(id) {
      let url = `/product-detail/${id}`;
      if (this.iosInReview) {
        this.$router.push(`${url}?inReview=1`);
      } else if (window.isElectron || isMobile()) {
        this.$router.push(url);
      } else {
        window.open(url);
      }
    },
  },
  created() {
    this.iosInReview = this.$route.query.inReview === "1";
  },
};
</script>

<style lang="scss" scoped>
.hidden-ios {
  display: none !important;
}
.course-card {
  cursor: pointer;
  color: var(--text-primary);
}

.course-card.big-card {
  width: 100%;
  padding: 20px;
  display: flex;
  border-radius: 24px;
  margin-bottom: 16px;
  background: var(--card-bg);

  .cover-wrap {
    .cover {
      width: 280px;
      height: 158px;
      border-radius: 24px;
      object-fit: cover;
    }
  }

  .info-wrap {
    height: 158px;
    margin-left: 16px;
    flex: 1;
    width: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      margin: 6px 0;
      font-weight: 500;
      font-size: 18px;
      color: var(--text-primary);
      line-height: 28px;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;
      .course-tag {
        position: relative;
        top: -1px;
        display: inline-block;
        height: 18px;
        background: var(--input-bg);
        border-radius: 4px;
        font-weight: 500;
        font-size: 12px;
        color: var(--text-secondary);
        line-height: 18px;
        text-align: center;
        // margin-right: 5px;
        padding: 0 5px;
      }
    }
    .course-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .price-activity-wrap {
      display: flex;
      align-items: center;
    }
    .price-wrap {
      .free-price {
        font-weight: 600;
        font-size: 24px;
        color: $saas-price-color;
        line-height: 33px;
      }
      .price,
      .activity-price {
        font-weight: 600;
        color: $saas-price-color;
        font-size: 24px;
        line-height: 33px;
        margin-right: 6px;
        i {
          font-weight: 600;
          color: $saas-price-color;
          font-size: 12px;
          line-height: 17px;
          font-style: normal;
        }
      }
      .price.text-through {
        font-weight: 400;
        text-decoration: line-through;
        color: var(--text-muted);
        font-size: 14px;
        i {
          font-weight: 400;
          font-size: 14px;
          color: var(--text-muted);
        }
      }
    }
    .activity-mark {
      display: flex;
      align-items: center;
      font-size: 14px;
      line-height: 16px;
      color: $saas-price-color;
      height: 24px;
      border-radius: 8px;
      border: 1px solid rgba($color: $saas-price-color, $alpha: 0.3);
      padding: 0 6px;
    }
    .data-STATS {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: var(--text-secondary);
      line-height: 20px;
      .separate {
        display: inline-block;
        width: 1px;
        height: 8px;
        background: var(--border-subtle);
        margin: 9px;
      }
      span {
        display: flex;
        align-items: center;
      }
    }
  }
}
.course-card.small-card {
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  width: 380px;
  height: 350px;
  padding: 20px;
  background: var(--card-bg);
  border-radius: 24px;
  .cover-wrap {
    margin-bottom: 12px;
    .cover {
      width: 340px;
      height: 191px;
      object-fit: cover;
      border-radius: 16px;
    }
  }
  .info-wrap {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    .title {
      font-weight: 500;
      font-size: 18px;
      color: var(--text-primary);
      line-height: 28px;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;
      .course-tag {
        position: relative;
        top: -1px;
        display: inline-block;
        height: 18px;
        background: var(--input-bg);
        border-radius: 4px;
        font-weight: 500;
        font-size: 12px;
        color: var(--text-secondary);
        line-height: 18px;
        text-align: center;
        // margin-right: 5px;
        padding: 0 5px;
      }
    }

    .course-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .price-activity-wrap {
      display: flex;
      align-items: center;
    }
    .price-wrap {
      .free-price {
        font-weight: 600;
        font-size: 24px;
        color: $saas-price-color;
        line-height: 33px;
      }
      .price,
      .activity-price {
        font-weight: 600;
        color: $saas-price-color;
        font-size: 16px;
        line-height: 33px;
        margin-right: 3px;
        i {
          font-weight: 600;
          color: $saas-price-color;
          font-size: 12px;
          line-height: 17px;
          font-style: normal;
        }
      }
      .price.text-through {
        font-weight: 400;
        text-decoration: line-through;
        color: var(--text-muted);
        font-size: 12px;
        i {
          font-weight: 400;
          color: var(--text-muted);
          font-size: 12px;
        }
      }
    }
    .activity-mark {
      display: flex;
      align-items: center;
      font-size: 12px;
      line-height: 16px;
      color: $saas-price-color;
      height: 24px;
      border-radius: 8px;
      border: 1px solid rgba($color: $saas-price-color, $alpha: 0.3);
      padding: 0 2px;
    }
    .data-STATS {
      display: flex;
      align-items: center;
      font-size: 13px;
      color: var(--text-secondary);
      line-height: 20px;
      .separate {
        display: inline-block;
        width: 1px;
        height: 8px;
        background: #e9e9e9;
        margin: 2px;
      }
      span {
        display: flex;
        align-items: center;
      }
    }
  }
}

// 适配
.h5-course-card.small-card {
  display: flex;
  flex-direction: column;
  width: 4.57rem;
  height: 5.35rem;
  border-radius: 0.32rem;
  overflow: hidden;
  margin-bottom: 0.21rem;
  .cover-wrap {
    .cover {
      width: 4.56rem;
      height: 2.56rem;
      border-radius: 0.32rem 0.32rem 0 0;
      object-fit: cover;
    }
  }
  .info-wrap {
    flex: 1;
    padding: 0.19rem;
    background: var(--card-bg, #fff);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      font-weight: 500;
      font-size: 0.4rem;
      color: var(--text-primary, #0d1400);
      line-height: 0.53rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;
      .course-tag {
        display: inline-block;
        height: 0.43rem;
        background: var(--input-bg, #f5f5f5);
        border-radius: 0.11rem;
        font-weight: 400;
        font-size: 0.29rem;
        color: var(--text-secondary, #515350);
        line-height: 0.43rem;
        text-align: center;
        // margin-right: 0.1rem;
        padding: 0 0.1rem;
        vertical-align: middle;
      }
    }

    .price-activity-wrap {
      display: flex;
      align-items: center;
    }
    .price-wrap {
      display: flex;
      align-items: center;
      height: 0.53rem;
      .free-price {
        font-weight: 800;
        font-size: 0.37rem;
        color: #f03349;
        line-height: 1;
      }
      .price,
      .activity-price {
        font-weight: 800;
        font-size: 0.32rem;
        color: #f03349;
        line-height: 1;
        margin-right: 0.11rem;
        i {
          font-weight: 800;
          font-size: 0.21rem;
          color: #f03349;
          line-height: 1;
          font-style: normal;
        }
      }
      .price.text-through {
        margin-top: 0.05rem;
        font-weight: 400;
        text-decoration: line-through;
        color: #747573;
        font-size: 0.21rem;
        line-height: 0.43rem;
        i {
          color: #747573;
        }
      }
    }
    .activity-mark {
      display: flex;
      align-items: center;
      font-size: 0.24rem;
      line-height: 0.43rem;
      color: $saas-price-color;
      height: 0.43rem;
      border-radius: 0.11rem;
      border: 0.01rem solid rgba($color: $saas-price-color, $alpha: 0.3);
      padding: 0 0.07rem;
    }
    .data-STATS {
      margin-top: 0.1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: 400;
      font-size: 0.29rem;
      color: var(--text-secondary, #515350);
      line-height: 0.4rem;
    }
  }
}
.h5-course-card.big-card {
  width: 100%;
  display: flex;
  margin-bottom: 0.21rem;
  border-radius: 0.32rem;
  background: var(--card-bg);
  padding: 0.27rem;
  .cover-wrap {
    .cover {
      width: 4.27rem;
      height: 2.4rem;
      border-radius: 0.21rem;
      object-fit: cover;
    }
  }
  .info-wrap {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    margin-left: 0.16rem;
    .title {
      font-weight: 500;
      font-size: 0.4rem;
      color: var(--text-primary);
      line-height: 0.53rem;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;
      .course-tag {
        display: inline-block;
        height: 0.43rem;
        background: var(--input-bg);
        border-radius: 0.11rem;
        font-weight: 400;
        font-size: 0.29rem;
        color: var(--text-secondary);
        line-height: 0.43rem;
        text-align: center;
        // margin-right: 0.1rem;
        padding: 0 0.1rem;
        vertical-align: middle;
      }
    }
    .price-activity-wrap {
      display: flex;
      align-items: center;
    }
    .price-wrap {
      display: flex;
      align-items: center;
      height: 0.53rem;
      // margin-right: 0.2rem;
      .free-price {
        font-weight: 800;
        font-size: 0.37rem;
        color: #f03349;
        line-height: 1;
      }
      .price,
      .activity-price {
        font-weight: 800;
        font-size: 0.37rem;
        color: #f03349;
        line-height: 1;
        margin-right: 0.11rem;
        i {
          font-weight: 800;
          font-size: 0.21rem;
          color: #f03349;
          line-height: 1;
          font-style: normal;
        }
      }
      .price.text-through {
        margin-top: 0.05rem;
        font-weight: 400;
        text-decoration: line-through;
        color: var(--text-muted);
        font-size: 0.21rem;
        line-height: 0.43rem;
        i {
          font-size: 0.21rem;
          color: var(--text-muted);
        }
      }
    }
    .activity-mark {
      display: flex;
      align-items: center;
      font-size: 0.24rem;
      line-height: 0.43rem;
      color: $saas-price-color;
      height: 0.43rem;
      border-radius: 0.11rem;
      border: 0.01rem solid rgba($color: $saas-price-color, $alpha: 0.3);
      padding: 0 0.07rem;
    }
    .data-STATS {
      margin-top: 0.2rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: 400;
      font-size: 0.29rem;
      color: var(--text-secondary);
      line-height: 0.4rem;
    }
  }
}
</style>
